import { render, staticRenderFns } from "./MapPetugas.vue?vue&type=template&id=5a24c72f&"
import script from "./MapPetugas.vue?vue&type=script&lang=js&"
export * from "./MapPetugas.vue?vue&type=script&lang=js&"
import style0 from "./MapPetugas.vue?vue&type=style&index=0&id=5a24c72f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports